// Sürücü Puantajı — filo dinlenme analizi tablosu.

import React, { useMemo, useState } from "react";

import { formatMinutes, formatNumber } from "../utils";

const SORT_ACCESSORS = {
  name: (r) => (r.driver.name || "").toLocaleLowerCase("tr"),
  tripCount: (r) => r.summary.tripCount,
  violationCount: (r) => r.summary.violationCount,
  minQualifyingRest: (r) =>
    r.summary.minQualifyingRestMinutes === null || r.summary.minQualifyingRestMinutes === undefined
      ? Number.MAX_SAFE_INTEGER
      : r.summary.minQualifyingRestMinutes,
  longestBlock: (r) => r.summary.longestBlockSpanMinutes,
};

const formatQualifyingRest = (minutes) => {
  if (minutes === null || minutes === undefined) return "—";
  return formatMinutes(minutes);
};

const RestFleetTable = ({ rows = [], onSelectDriver, t }) => {
  const [sortKey, setSortKey] = useState("violationCount");
  const [sortDir, setSortDir] = useState("desc");

  const sorted = useMemo(() => {
    const accessor = SORT_ACCESSORS[sortKey] || SORT_ACCESSORS.violationCount;
    const factor = sortDir === "asc" ? 1 : -1;
    return [...rows].sort((a, b) => {
      const av = accessor(a);
      const bv = accessor(b);
      if (av < bv) return -1 * factor;
      if (av > bv) return 1 * factor;
      return 0;
    });
  }, [rows, sortKey, sortDir]);

  const handleSort = (key) => {
    if (key === sortKey) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortKey(key);
      setSortDir(key === "name" ? "asc" : "desc");
    }
  };

  const sortArrow = (key) => (key === sortKey ? (sortDir === "asc" ? " ▲" : " ▼") : "");

  return (
    <div className="dp-table-wrap">
      <table className="dp-table dp-table--rest">
        <thead>
          <tr>
            <th className="dp-table__driver dp-table__sortable" onClick={() => handleSort("name")}>
              {t("driverPerformance.table.driver")}
              {sortArrow("name")}
            </th>
            <th className="dp-table__num dp-table__sortable" onClick={() => handleSort("tripCount")}>
              {t("driverPerformance.rest.table.trips")}
              {sortArrow("tripCount")}
            </th>
            <th className="dp-table__num dp-table__sortable" onClick={() => handleSort("violationCount")}>
              {t("driverPerformance.rest.table.violations")}
              {sortArrow("violationCount")}
            </th>
            <th className="dp-table__num dp-table__sortable" onClick={() => handleSort("minQualifyingRest")}>
              {t("driverPerformance.rest.table.minQualifyingRest")}
              {sortArrow("minQualifyingRest")}
            </th>
            <th className="dp-table__num dp-table__sortable" onClick={() => handleSort("longestBlock")}>
              {t("driverPerformance.rest.table.longestBlock")}
              {sortArrow("longestBlock")}
            </th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((row) => {
            const s = row.summary;
            const hasViolations = s.violationCount > 0;
            return (
              <tr
                key={row.driver.id}
                className={`dp-table__row${hasViolations ? " dp-table__row--warn" : ""}`}
                onClick={() => onSelectDriver?.(row.driver)}
                title={t("driverPerformance.rest.openDetail")}
              >
                <td className="dp-table__driver-cell">
                  {row.driver.name}
                  {!row.driver.isActive && <span className="dp-table__inactive"> ({t("driverPerformance.inactive")})</span>}
                </td>
                <td className="dp-table__num">{formatNumber(s.tripCount)}</td>
                <td className="dp-table__num">
                  {hasViolations ? (
                    <span className="dp-rest-badge dp-rest-badge--warn">{formatNumber(s.violationCount)}</span>
                  ) : (
                    formatNumber(0)
                  )}
                </td>
                <td className="dp-table__num">{formatQualifyingRest(s.minQualifyingRestMinutes)}</td>
                <td className="dp-table__num">{s.longestBlockSpanMinutes > 0 ? formatMinutes(s.longestBlockSpanMinutes) : "—"}</td>
              </tr>
            );
          })}
          {sorted.length === 0 && (
            <tr>
              <td colSpan={5} className="dp-table__empty">
                {t("driverPerformance.noDrivers")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RestFleetTable;
